import PropTypes from 'prop-types'
import { HeaderTitle } from '../../../../common/HeaderTitle.jsx'
import { SimpleTable } from '../../../../common/simpleTable/SimpleTable.jsx'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import { Icons } from '../../../../common/Icons.jsx'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import {ModalProcesHarmonogramu} from '../../lib/components/modals.jsx'
import {useListaProcesuHarm} from "../../../../../api/domain/elementyRejstru/queries/useListaProcesuHarm.jsx";
import {useMeta} from "../../../../../api/domain/elementyRejstru/queries/useMeta.jsx";
import {LinkContainer} from "react-router-bootstrap";
import {createTableListaProcesuHarm} from "../../../planHarm/lib/columns/tableListaProcesuHarm.jsx";

const ViewListaProcesuHarmonogramu = () => {
    const [currPozycja, setCurrPozycja] = useState({})
    const { rejestrId, id } = useParams()
    const listaPozycji = useListaProcesuHarm(rejestrId)
    const metaDane = useMeta(rejestrId)
    const isAnulowana = metaDane.data?.item?.status === 'ANULOWANA'
    const listaProcesu = listaPozycji.data?.list || listaPozycji.data || [];
    const titleName = `Lista procesu planowanego harmonogramu dla projektu o id: ${rejestrId || ''}`
    const [modalState, setModalState] = useState({
        delete: false,
        dodaj: false,
    })
    const rola = useSelector((state) => state.user.role)
    const permissions = useSelector((state) => state.user.permissions)
    const canModifyProcess = Array.isArray(permissions) && permissions.includes('rejestr_obsluga_modyfikacja')
    const openModal = (type, data) => {
        setCurrPozycja(data)
        setModalState((prev) => ({ ...prev, [type]: true }))
    }

    const closeModal = (type) =>
        setModalState((prev) => ({ ...prev, [type]: false }))

    const handleAction = (row, type) => {
        openModal(type, row)
    }

    const procesyZWersja = listaProcesu.filter(p => p.plan_harm_id !== null && p.wersja !== null);

    const lastProcesWithVersion = procesyZWersja.length > 0
        ? procesyZWersja.reduce((latest, current) => {
            return current.id > latest.id ? current : latest
        }, procesyZWersja[0])
        : null;

    const latestPlanHarmId = lastProcesWithVersion ? lastProcesWithVersion.plan_harm_id : null;
    const latestWersja = lastProcesWithVersion ? lastProcesWithVersion.wersja : null;


    const allow = {
        show: {
            dodaj: rola === 'wp' || canModifyProcess,
        },
    }

    const modals = () => (
        <>
            <ModalProcesHarmonogramu
                show={modalState.dodaj}
                handleClose={() => closeModal('dodaj')}
                currPozycja={currPozycja}
            />
        </>
    )
    const th = () => {
        return (
            <>
                <th>Akcje</th>
            </>
        )
    }

    const td = (row) => {
        const planHarmId = row.plan_harm_id;
        const isZlozony = row.status === 'ZŁOŻONY'

        const allowItem = {
            show: {
                planHarm: isZlozony,
                gantt: isZlozony,
            },
        }

        return (
            <>
                <td>
                    <div className={'d-flex gap-2'}>
                        {allowItem.show.planHarm && (
                            <LinkContainer
                                to={`/${rola}/harm/podglad/${rejestrId}/${planHarmId}`}
                            >
                                <ButtonWithIcon
                                    variant={'secondary'}
                                    onClick={() => handleAction(row, 'view')}
                                    size={'sm'}
                                    icon={<Icons.eye/>}
                                    title='Podgląd planowanego harmonogramu'
                                />
                            </LinkContainer>
                        )}
                        {allowItem.show.gantt && (
                            <LinkContainer
                                to={`/${rola}/harm/gantt/${rejestrId}/${planHarmId}`}
                            >
                                <ButtonWithIcon
                                    variant={'secondary'}
                                    onClick={() => null}
                                    size={'sm'}
                                    icon={<Icons.charts/>}
                                    title='Pokaż wykres planowanego harmonogramu'
                                />
                            </LinkContainer>
                        )}
                    </div>
                </td>
            </>
        )
    }

    return (
        <>
            {Object.keys(modalState || {}).some((k) => k) && modals()}
            <HeaderTitle
                breadcrumbLinks={[
                    {label: 'Wszystkie projekty', to: `/${rola}/rejestr/lista`},
                    {label: titleName}
                ]}
                home
                nav
                destination={`/${rola}/rejestr/lista`}
                size={'fs-3'}
                title={titleName}
            />
            <div className={'d-flex justify-content-end gap-3'}>
                {allow.show.dodaj && (
                    <ButtonWithIcon
                            size={'lg'}
                            onClick={() => handleAction({
                                rejestrId: rejestrId,
                                plan_harm_id: latestPlanHarmId,
                                wersja: latestWersja,
                                id: null,
                            }, 'dodaj')}
                            text={'Dodaj zdarzenie procesu planowanego harmonogramu'}
                            variant={'primary'}
                            icon={<Icons.add />}
                            title='Dodaj zdarzenie procesu planowanego harmonogramu'
                            disabled={isAnulowana}
                        />
                    )}
            </div>
            <SimpleTable
                detailKey={'oper_profile'}
                columns={createTableListaProcesuHarm()}
                addTh={th}
                addTd={td}
                data={listaProcesu}
                initialSortingColumn={{
                    id: 'id',
                    sort: 'desc',
                }}
            />
        </>
    )
}

ViewListaProcesuHarmonogramu.propTypes = {
    moje: PropTypes.bool,
}

export default ViewListaProcesuHarmonogramu
